// frontend-web/src/pages/UserView.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../api";

export default function UserView() {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
  const loadUser = async () => {
    try {
      const res = await api.get(`/admin/users/${id}`);

      console.log("User API Response:", res.data);  // Debug log

      // FIX: Correct key from backend → "data"
      setUser(res.data.data);

    } catch (err) {
      console.error("User fetch error:", err);
      setError("Unable to load user details.");
    }
    setLoading(false);
  };

  loadUser();
}, [id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen text-lg font-semibold">
        Loading User Details...
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen text-red-600 font-semibold">
        {error}
      </div>
    );
  }

  if (!user) {
    return (
      <div className="flex justify-center items-center h-screen text-gray-600">
        No user data found.
      </div>
    );
  }

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-blue-700">User Profile</h1>

      <div className="bg-white shadow-xl rounded-2xl p-6 border border-gray-200">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">

          {/* Name */}
          <div>
            <span className="font-semibold text-gray-700">Full Name:</span>
            <p className="text-gray-900">{user.name || "N/A"}</p>
          </div>

          {/* Email */}
          <div>
            <span className="font-semibold text-gray-700">Email:</span>
            <p className="text-gray-900">{user.email || "N/A"}</p>
          </div>

          {/* Phone */}
          <div>
            <span className="font-semibold text-gray-700">Phone:</span>
            <p className="text-gray-900">{user.phone || "N/A"}</p>
          </div>

          {/* Class */}
          <div>
            <span className="font-semibold text-gray-700">Class:</span>
            <p className="text-gray-900">{user.clazz || "N/A"}</p>
          </div>

          {/* State */}
          <div>
            <span className="font-semibold text-gray-700">State:</span>
            <p className="text-gray-900">{user.state || "N/A"}</p>
          </div>

          {/* Board / Prep */}
          <div>
            <span className="font-semibold text-gray-700">Board / Prep:</span>
            <p className="text-gray-900">{user.board_or_prep || "N/A"}</p>
          </div>

          {/* Role */}
          <div>
            <span className="font-semibold text-gray-700">Role:</span>
            <p className="text-gray-900 capitalize">{user.role || "N/A"}</p>
          </div>

          {/* Language */}
          <div>
            <span className="font-semibold text-gray-700">Language:</span>
            <p className="text-gray-900">{user.language || "N/A"}</p>
          </div>

          {/* Subscription Status */}
          <div>
            <span className="font-semibold text-gray-700">Subscription Status:</span>
            <p className={user.is_subscribed ? "text-green-600" : "text-red-600"}>
              {user.is_subscribed ? "Active" : "Not Subscribed"}
            </p>
          </div>

          {/* Address */}
          <div className="sm:col-span-2">
            <span className="font-semibold text-gray-700">Address:</span>
            <p className="text-gray-900">{user.address || "N/A"}</p>
          </div>

          {/* Created At */}
          <div className="sm:col-span-2">
            <span className="font-semibold text-gray-700">Date Joined:</span>
            <p className="text-gray-900">
              {user.created_at ? new Date(user.created_at).toLocaleString() : "N/A"}
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}
